export const videoUrls = {
        'intro-videos': {
            'doc-melillo-message': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/07ac47868ac2e584dec22f0b9ed2955a/watch',
            'melillo-method-prep': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/94dc55f9d52eaa8c9c6b1441e6d1b227/watch',
            'report-of-finding': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/87b8df7f979edfc8e05c117b0962e79d/watch',
            '10-level-system': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ff875622bdd5173b70f67ba3504d0b1f/watch',
            //'sallie': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6bf703a27dba2336ceb75f3cf777b860/watch',
            //'sallie_spanish': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/c2fafe3c85730acb98d64dd6a4368451/watch',
            'qeeg-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/933ee5299cfb635d792a2ec37051f031/watch',
            'bridget-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f26f4f6ae162d6a6c85e486c16b2b346/watch',
            'jesse-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/bf6e5fe8df907bcf009283d8d47b923b/watch',
            'ty-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/349dcae59032b255a190faf5b0e60e58/watch',
            'intro-to-rpm': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/c7d486a7a9d14a60883bc06fb82cfd1e/watch'
        },
        'primitive-reflex': {
            'pr-intro-home': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8f6dcc376c752585131cc74c966924d9/watch'
        },
        'pr-levels-1': {
            'pr-dr-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/45a283c14ecbc6c2cc51c9a07d8b0d89/watch',
            'pr-intro-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b7e0079129d6d74f14c0e21e94c0122e/watch',
            'pg-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/cb994619fcec4a6b5ce082130b49987b/watch',
            'pg-1-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0eef88329cfd29458fe5f54d751a872a/watch',
            'root-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7acc5c09d6dc97990d86c8be02c5f2e9/watch',
            'root-1-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/942faa54c4fa57321579730d7e43d35d/watch',
            'snout-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/99bfda6645934b1a7111076920982e96/watch',
            'snout-1-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0674863847de1fa843b1008b53a72fb8/watch',
            'bab-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/152f4946c817ac8db4865d4811096d20/watch',
            'bab-1-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/22b27d67e24eef35f119c2644a7efd7a/watch',
            'sg-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/702356ff502f088d1056963c81994de3/watch',
            'sg-1-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/28646ec6ffa01f6dbba6bf17a51fa708/watch',
            'atnr-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6ea97cefbd226fbbc277c9220cc8843c/watch',
            'stnr-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/425216c0840c97fe9f0df7be710d8b1c/watch',
            'moro-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/478969696e5d98e3cb57ae4e6b0c6934/watch',
            'tlr-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a8e30a37a21a424a748b697af48c8ccd/watch'
        },
        'pr-levels-2': {
            'pr-dr-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/45a283c14ecbc6c2cc51c9a07d8b0d89/watch',
            'pr-intro-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b7e0079129d6d74f14c0e21e94c0122e/watch',
            'pg-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/cb994619fcec4a6b5ce082130b49987b/watch',
            'pg-2-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0eef88329cfd29458fe5f54d751a872a/watch',
            'root-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7acc5c09d6dc97990d86c8be02c5f2e9/watch',
            'root-2-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/942faa54c4fa57321579730d7e43d35d/watch',
            'snout-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/99bfda6645934b1a7111076920982e96/watch',
            'snout-2-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0674863847de1fa843b1008b53a72fb8/watch',
            'bab-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/152f4946c817ac8db4865d4811096d20/watch',
            'bab-2-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/22b27d67e24eef35f119c2644a7efd7a/watch',
            'sg-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/702356ff502f088d1056963c81994de3/watch',
            'sg-2-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/28646ec6ffa01f6dbba6bf17a51fa708/watch',
            'atnr-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6ea97cefbd226fbbc277c9220cc8843c/watch',
            'stnr-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/425216c0840c97fe9f0df7be710d8b1c/watch',
            'moro-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/478969696e5d98e3cb57ae4e6b0c6934/watch',
            'tlr-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a8e30a37a21a424a748b697af48c8ccd/watch'
        },
        'pr-levels-3': {
            'pr-intro-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8eac46eeb92a01a5471d59854821dbe4/watch',
            'pg-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/63941c89e00913e893b22efc0124398e/watch',
            'pg-3-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/dc3ba0f50060182b77a80f5faff1f79e/watch',
            'root-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/2ecda79972f6af050445d0111c9fb74d/watch',
            'root-3-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b13c8f19b6f796189c3d9eebe3f4efb1/watch',
            'snout-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5e9139a55d4e5c59a9feefcfd22c2cb8/watch',
            'snout-3-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0d0aeae3cb01665d2cf1039549b5aba0/watch',
            'bab-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/42a1a584eeb96347477e33c2e7901e7a/watch',
            'bab-3-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ddb4eedcb486b27798221e1d64d0bb2d/watch',
            'sg-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/576d5401ec3ad753ba86a83ce378d340/watch',
            'sg-3-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/14396aeb6e79a9d49a8542a94979ea4d/watch',
            'atnr-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f2da2e55dc9ac6b37ed089e901ad75f9/watch',
            'stnr-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f4daf25c5180d3a8684ce2a1d2d74c17/watch',
            'moro-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/cee9216276a90bda9b4f497916276c08/watch',
            'tlr-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/97221c083b8889db2a8ab46afec0bd1e/watch'
        },
        'pr-level-4': {
            'pr-intro-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8eac46eeb92a01a5471d59854821dbe4/watch',
            'pg-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/63941c89e00913e893b22efc0124398e/watch',
            'pg-4-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/dc3ba0f50060182b77a80f5faff1f79e/watch',
            'root-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/2ecda79972f6af050445d0111c9fb74d/watch',
            'root-4-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b13c8f19b6f796189c3d9eebe3f4efb1/watch',
            'snout-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5e9139a55d4e5c59a9feefcfd22c2cb8/watch',
            'snout-4-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0d0aeae3cb01665d2cf1039549b5aba0/watch',
            'bab-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/42a1a584eeb96347477e33c2e7901e7a/watch',
            'bab-4-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ddb4eedcb486b27798221e1d64d0bb2d/watch',
            'sg-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/576d5401ec3ad753ba86a83ce378d340/watch',
            'sg-4-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/14396aeb6e79a9d49a8542a94979ea4d/watch',
            'atnr-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f2da2e55dc9ac6b37ed089e901ad75f9/watch',
            'stnr-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f4daf25c5180d3a8684ce2a1d2d74c17/watch',
            'moro-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/cee9216276a90bda9b4f497916276c08/watch',
            'tlr-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/97221c083b8889db2a8ab46afec0bd1e/watch'
        },
        'pr-level-5': {
            'pg-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b47ab909369804663d2038a33a531e4f/watch',
            'root-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0e13e29f315315d9abe9076e333ec2da/watch',
            'snout-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/75d937a88b38d1ae4932b43ee11c15da/watch',
            'bab-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/30791b5bad6d81f96465e16d1aba5038/watch',
            'sg-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3f01440dcaaf45ca907d800cb4c1b1bd/watch',
            'atnr-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/e96358071db8cb8f7c8e0405cd746f09/watch',
            'stnr-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/38a7f57cbf45dd24c7ebe42f607f81b2/watch',
            'moro-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6ecbf554b02beb4fde5ea77407e82d71/watch',
            'tlr-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f835459826d072a5bc6d7190cbb222d6/watch'
        },
        'pr-level-6': {
            'pg-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6f3f0bc7b4a3997b9584d39bdd85d49a/watch',
            'root-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/849ec72e5fd263cad11a08a77f4064b3/watch',
            'root-6-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9c0652ae02a6392494cfed7502861d2d/watch',
            'snout-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/53d9b8644d1c8b69080c312f50ef90c5/watch',
            'snout-6-rez': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a2cba815b68f525808212b57e209c153/watch',
            'bab-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/784825a0efb2da838f6b4749b7d1b186/watch',
            'sg-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b511133d7cd840ae73eeb6f09812d47f/watch',
            'atnr-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ca7fe1ad8fd7046d699a3c7e73f2a9c4/watch',
            'stnr-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b8d84113f946fef6162429c232a920f0/watch',
            'moro-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9d194eae8e3c89e84deeffe8fa0b04ed/watch',
            'tlr-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/706c9131b861c9e28794d4ccffd48094/watch'
        },
        'pr-level-7': {
            'pg-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/93d08b5a02752012e774484e43e1c6bc/watch',
            'root-snout-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6e896d5b5738593227e5a3f50bc2bf78/watch',
            'bab-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9b00591e11b6e37d975564e1a407b9f1/watch',
            'sg-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/47a9248fed80e70df7215579c8c13f0b/watch',
            'atnr-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1faee6952f0cace4746a4db6866e84bb/watch',
            'stnr-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/4f8bcb876881d362a055310daee6743b/watch',
            'moro-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5e83d58aaa5f1a2f5446125b895e459f/watch',
            'tlr-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9d71b35d2c32212b481ca68705fe8c01/watch'
        },
        'pr-level-8': {
            'pg-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f6353738bdf3701f15777478ecbe3622/watch',
            'root-snout-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/cbf9f674fce702c5fee37cb7d8584391/watch',
            'bab-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7d412640dbeafea6f53416ed588e38ed/watch',
            'sg-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0f8117b11f1c85c8c35bfb18f87bcb5a/watch',
            'atnr-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/41905ec3d5d2347dbb51f672bb3736c4/watch',
            'stnr-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3756855dead0c8e0547969563b694482/watch',
            'moro-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/41435f50c98862c45e99db2c29a3513e/watch',
            'tlr-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3e90c31cf587a57312066abbae3eeed2/watch'
        },
        'pr-level-9': {
            'pg-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d4d7dda8befa0ce1eed473284331d087/watch',
            'root-snout-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/67513833bc5c8a57f89259367cc8fc6a/watch',
            'bab-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0df259b2692642fdd2711c92f96bcb6a/watch',
            'sg-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f8e196734f956bffde633befbd127aea/watch',
            'atnr-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a4e19a67a84ae94bae67a705cb93acc9/watch',
            'stnr-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/68b069e6d13b4665812ce26191d6926b/watch',
            'moro-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5bc4ed18770de58cc2e0369452a1ba40/watch',
            'tlr-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d1fb66abbe7ce26eda764be6d3095813/watch'
        },
        'pr-level-10': {
            'pg-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d4d7dda8befa0ce1eed473284331d087/watch',
            'root-snout-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/67513833bc5c8a57f89259367cc8fc6a/watch',
            'bab-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0df259b2692642fdd2711c92f96bcb6a/watch',
            'sg-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f8e196734f956bffde633befbd127aea/watch',
            'atnr-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a4e19a67a84ae94bae67a705cb93acc9/watch',
            'stnr-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/68b069e6d13b4665812ce26191d6926b/watch',
            'moro-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5bc4ed18770de58cc2e0369452a1ba40/watch',
            'tlr-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d1fb66abbe7ce26eda764be6d3095813/watch'
        },
        'core-level-1': {
            'sb-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6262a0ceef97d6d882992c545e79c184/watch',
            'cu-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/47fc02ba932097f7091e6d81f9541478/watch',
            'lsp-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ebdeb2d25e1b8816265546ce12aae7aa/watch',
            'pb-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/24eae2284b1377e7f2d46ccded1412ef/watch',
            'pu-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f785ec1f8a3694fec5d6215295642eed/watch',
            'psh-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/2e309354e458b2cae1c2f9f7cc671b03/watch'
        },
        'core-level-2': {
            'sb-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/71bf2d3f6aa19c5a24468f7ae9deb5b4/watch',
            'cu-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1cf68b03fb6abbe76a7260e1649e00e6/watch',
            'lsp-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/4b3acd5e240c2b0d93f59c8045979cc1/watch',
            'pb-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6f2cdcddc449c74947cde01ed231e9c0/watch',
            'pu-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/282462f78a21339f2834c955eacd6181/watch',
            'psh-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/e5d5fc6764214a58b7b263810c0bc7f1/watch'
        },
        'core-level-3': {
            'sb-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ed9ee391048a2cee5bfff10722b7bdf8/watch',
            'cu-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/2976aa806b1425e87e9d75daee2814b6/watch',
            'lsp-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f9bf8efc9a65b38e1a52b0381f34391e/watch',
            'pb-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b0d3d49604cfedbcf74444ed32c5a973/watch',
            'pu-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/599bbbd901586b534cd780e84542c89c/watch',
            'psh-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1055b44c5b028310beb73e47161384cd/watch'
        },
        'core-level-4': {
            'sb-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ca34c6e0e3b49f4cda16598307f6f921/watch',
            'cu-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/346aa92aae65e6ca2f296bc9e7fa996e/watch',
            'lsp-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d845fb3347245a59cea18beaa62b4c09/watch',
            'pb-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1a042d30ed66600d630189efccf18a56/watch',
            'pu-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/baa84959e1bfebfb9c1636ab101fa230/watch',
            'psh-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3514339f58107de8cb8a6ea364a1d376/watch'
        },
        'core-level-5': {
            'sb-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/eb7f63c65ab34a7dd3ccca3d2b9ac1f0/watch',
            'cu-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0db74986d7131406e1c4d33ec4e34c23/watch',
            'lsp-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/c95040c0988b23e66d27b5ee59444cfe/watch',
            'pb-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3c446acd9e4ef7a854f06b57734fb642/watch',
            'pu-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/28ddfc484f5280c6beaa6b83e75ca651/watch',
            'psh-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8a0bb78392bf6e6086c56ff49293dd27/watch'
        },
        'core-level-6': {
            'sb-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1c7f49f445e7c316e055065fa3854cf5/watch',
            'cu-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/bcc6adcd24565c3903bcb381c98b3f9e/watch',
            'lsp-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/94f0b226bff9ebbfece7459d30a86de8/watch',
            'pb-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/56c063af9f49c94e883adcb6ce8ea7ab/watch',
            'pu-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5d94f452e128ff5d1938b2f8f8e4de66/watch',
            'psh-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/bce30ac6a8a5d54101871f688975cd53/watch'
        },
        'core-level-7': {
            'sb-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/529b79344bdfa05c9d1e720bba88448b/watch',
            'cu-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/798e3bda272615c92a4ce53155dc379b/watch',
            'lsp-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/4bc818d3ff46ca1732d8df40999fa4ff/watch',
            'pb-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/e050ecd1edd584765ce8f9a8c0368fd0/watch',
            'pu-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/db42f4870e18ffcf67e0ad48f00c87ae/watch',
            'psh-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/871d409d05c4419e773958d2320206ab/watch'
        },
        'core-level-8': {
            'sb-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/47e73b40a360303161e036617866fb3c/watch',
            'cu-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9531a8b5eb56cb5b4c71a5f76a758b7b/watch',
            'lsp-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d44876a8c5832dd62fbceb43ef02d6b5/watch',
            'pb-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/bb29ec21e8f14be5baaa6da37a7b828a/watch',
            'pu-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7b1b8aaded968fe33de939bdd9ebf988/watch',
            'psh-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6dc93dadb8ead7efe1ca90c95bbcfd20/watch'
        },
        'core-level-9': {
            'sb-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/53291f93c5f7adc42f9645e366701dcf/watch',
            'cu-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a4e0815114a56222d32e19a04f4bc283/watch',
            'lsp-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ff8a3e00152457d91c869b14de2a600c/watch',
            'pb-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7f2761ce3210cf74c3b9268eaaf74d3a/watch',
            'pu-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a4b532060b9c214481209836574f2a3f/watch',
            'psh-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/91dc6a0b855fb00900aec68aae52a879/watch'
        },
        'core-level-10': {
            'sb-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8155cf98ae2e6af8b78fad26cdf01d6e/watch',
            'cu-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/93caa170fdee21b71a44d2bdbbdc33ad/watch',
            'lsp-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/587742e3f03d757c87681ee09960d64b/watch',
            'pb-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8873af7c314a07ed7abf7ff955cb812b/watch',
            'pu-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5fd62a406e9b863c21525dff66987b77/watch',
            'psh-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9b6cec4ef50a68ad7d16d09d7ba29dd5/watch'
        },
        'balance': {
            'bal-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1b441c40453005604a2fd104cf5f47af/watch',
            'bal-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/c09567043aef86b805ef5270a21f1aab/watch',
            'bal-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5c9cc5c241016f016d04133a4367b9eb/watch',
            'bal-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b0a7790068c2a058eb8911884ddb06fa/watch',
            'bal-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ef951a41784793a2e79c347033c2cef5/watch',
            'bal-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0d01db2c9ece8118354a9d7082b8732f/watch',
            'bal-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9da37f3735f2b374801f69e12f78b7d7/watch',
            'bal-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/e96a84979e38c55a7d06a032912fd930/watch',
            'bal-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/aeba0cd8da64368bdde196c3c85e74b1/watch',
            'bal-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/192c358e906f1505fb3b9c4a9f0ec817/watch'
        },
        'oculomotor': {
            'okn-drum': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9b66f5e1e77b0172e87b42408670a3df/watch',
            'ocul-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/66f9338017413f3a2be957fd58b66249/watch',
            'ocul-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/c67c827e10cc211d56c433cf0b582d38/watch',
            'ocul-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/4bbaaf47955d2d80adb9c7eed1bac1df/watch',
            'ocul-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/27905909b2fd2425287ecf5ebb15b74e/watch',
            'ocul-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/e4e2bc48fe9ea5d2c080caed75a0fca6/watch',
            'ocul-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/c2572d17b645088afedb7bfa7a0f99e7/watch',
            'ocul-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/489e558bf79a63bef4ff5872d895a1fd/watch',
            'ocul-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b76b3249e18c069e9d12369cab119e04/watch',
            'ocul-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3b3a64b34a0239c5306172a922b83709/watch',
            'ocul-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/acda9ec21b7d52816abcdf3449e71878/watch'
        },
        'vestibular': {
            'vest-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d6f200c8320c02eab31cbf317bfb6c1f/watch',
            'vest-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8c2ea08138e3fd78d1d189a2c166348c/watch',
            'vest-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a4fae914067d7573a5fcfe90cd910a28/watch',
            'vest-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7f610e0b067b6162076797744e5257b9/watch',
            'vest-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/95d52cf7af133584660ec275ff6d5fbc/watch',
            'vest-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1b1ae088f1d1347e73cd3503e442f3cf/watch',
            'vest-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d8b4b72f86fa4b61ee167dd4e928e6a6/watch',
            'vest-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/432a290d6a0c5e8a4c26f6bd9662d3ea/watch',
            'vest-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/94ba218adffaf7394a69b3c3e8b55585/watch',
            'vest-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d375ab29cb0dc7863af3b90cebacbe5a/watch'
        },
        'olfactory': {
            'olf-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/4bf65824cf3a33d60142d6baca61add3/watch',
            'olf-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/99ad4c5437ba5a9234f9ff03ebaba081/watch',
            'olf-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b8e547b79abcdb9ac566b96f97527773/watch',
            'olf-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/afa1cefe49344a5f19879a540d82ab8e/watch',
            'olf-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9bbca7dffe9e80da00fbde6a426392b8/watch',
            'olf-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ea58b45f043c115b17cc533601bbe795/watch',
            'olf-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f8632fa0a7f30fc6b96398e90cd0ab4b/watch',
            'olf-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f3aa0f8f965711c67619611e0f11e653/watch',
            'olf-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/23c7278006ae254d34919c8e992c8a92/watch',
            'olf-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f277b7c210ab7fbc96dab208ffc8d35e/watch'
        },
        'metrotimer': {
            'metro-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/630f9930fbb2d8eab67cbc1d40576327/watch',
            'metro-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/64c43916c476bb8521599f71daf47bc4/watch',
            'metro-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a97a1ef35ed6540d7d40a53d8fb254a9/watch',
            'metro-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5858cc454f607acb41633b71d24b6c04/watch',
            'metro-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/58d3628c1e44395571197ac522e3000c/watch',
            'metro-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/55a57f32a2ab948971520ad78fa20ac2/watch',
            'metro-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/24b3171eac3c502559ef360b86594029/watch',
            'metro-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/89fa968bcb654327714c321b7293c783/watch',
            'metro-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/04a17642ddb67d60dd2b657661736899/watch',
            'metro-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0db205f6a058a39025e95bb87426f095/watch',
            'metro-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/2c580428c52894047978173f8a367203/watch'
        },
        'interactive-metronome': {
            'int-metro-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/205dcc2b3ce8101eb45ad5a93a4577ac/watch',
            'int-metro-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/97b4f949130b84f2e938bd323562b910/watch',
            'int-metro-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/cdab8ed57022105158500404236b7da9/watch',
            'int-metro-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/029f86c1e42907d5db0f5697d16752ec/watch',
            'int-metro-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/03429ef09f6fa78f89666f7d8e005b15/watch',
            'int-metro-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/65f309f562d4dba3aa91df5b02d852ce/watch',
            'int-metro-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/552e586ac9e39bedbeabb7042ff2b2fe/watch',
            'int-metro-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7c4efbcc4ac1b1583c186c90bcaf7734/watch',
            'int-metro-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/da2900fd39c2fda23f7789dee7fac78e/watch',
            'int-metro-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5a85a4744e55e8736d6268f3445a4206/watch'
        },
        'sensory-equipment': {
            'galvanic': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/e2f40ce8242387670d676cc2f74cfc90/watch',
            'bone-conduction': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7c324c767c8d2e7daab3167a55b19a20/watch',
            'tens': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/bec7cea5881981aeb80dc2386c7879ff/watch'
        },
        'transcranial': {
            'trans-brain-driver': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d6d424d7d6bcb29b05e1ccaec570d58c/watch',
            'trans-saline': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/37cc58d71e5abfb587f1406808b46d8f/watch',
            'trans-level-select': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1018b07b376e0c7ac3d023d90adcc6d7/watch',
            'trans-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/fb87c014d9a5709b976b7af9f63486a4/watch',
            'trans-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3d6b6344802f2778bf3fced72beac814/watch',
            'trans-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6e6119930ac0d73d4e512aefb0aba5f6/watch',
            'trans-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/67d59b61b9342219f11e4ed1bb13eaa1/watch',
            'trans-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/45b171a6077064d4ea30f16f12ce3d57/watch',
            'trans-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9a70bd901ceb1122d2dce878ec54f129/watch',
            'trans-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0edca5b127c6ade0e9af0bdfa5983d7e/watch',
            'trans-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/49821a31d7f85aaa7aa1da8a3a92c0ac/watch',
            'trans-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b62f5ad63f53766ec9393438495f7ba6/watch',
            'trans-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/4fddee9e8eb941a8af0c19dafa0d6f9f/watch'
        },
        'eyelights': {
            'eyelights-instructions': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/49fc96a411eafdad0f0c886ca4b5dd2e/watch',
            'eyelights-levels': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0a36c7169489c1b46015afb1483e6bb1/watch'
        },
        'pons': {
            'pons-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b997b6cdc13572a8485b5a2021188ea8/watch',
            'pons-practical': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/c783a916dd4e8063129d5316d409d1b5/watch',
            'pons-1': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8ac72d7c699dc32d307cfac81e40d18f/watch',
            'pons-2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/f98c4c80bbaa9b5bba5b671566473aff/watch',
            'pons-3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/090da0f5843c75619e3abe7405139f31/watch',
            'pons-4': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8d439972023bce63b07a4719ca172536/watch',
            'pons-5': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/32c083b99c7be303b94e858081d4eebe/watch',
            'pons-6': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/aa9e4289c93f819f32309d28233e51de/watch',
            'pons-7': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0400cbe9cf67e6368923222a399fcd9e/watch',
            'pons-8': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/07d67c4f2f4d319f7a27d3f27dd42c91/watch',
            'pons-9': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/bdb49cf038cfdeab70d4441562c2c7a7/watch',
            'pons-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/03cd30a6a787c7a77a12d42772ca5901/watch'
        },
        'photobiomodulation': {
            'laser-intro': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/57ea147f79cb617bb69c2538ec28fa77/watch',
            'laser-setup': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/4d8d71cab53f0a6c2226669182b7f942/watch'
        },
        'left-hemisphere': {
            'left-1':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/94a3530e55930833a35bf599f952167d/watch',
            'left-2':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/fb0d5f31c4ac8b47688b9d0c33975bbd/watch',
            'left-3':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/fb0d5f31c4ac8b47688b9d0c33975bbd/watch',
            'left-4':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/fb0d5f31c4ac8b47688b9d0c33975bbd/watch',
            'left-5':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a0944f931a3f6cc5cc1b1498ae19f1a8/watch',
            'left-6':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a0944f931a3f6cc5cc1b1498ae19f1a8/watch',
            'left-7':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a0944f931a3f6cc5cc1b1498ae19f1a8/watch',
            'left-8':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9821be1b977da425521315e19f9e15ac/watch',
            'left-9':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9821be1b977da425521315e19f9e15ac/watch',
            'left-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0d34245400f313a3978853dea9eb528d/watch'
        },
        'right-hemisphere': {
            'right-1':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0c9ebd2c79b53de364f5c1256eae6300/watch',
            'right-2':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/fd4e8912d91cba30fddfb0053637f7d6/watch',
            'right-3':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/fd4e8912d91cba30fddfb0053637f7d6/watch',
            'right-4':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/fd4e8912d91cba30fddfb0053637f7d6/watch',
            'right-5':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3ae034680ff7436da9f1b9dfe8348c1b/watch',
            'right-6':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3ae034680ff7436da9f1b9dfe8348c1b/watch',
            'right-7':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3ae034680ff7436da9f1b9dfe8348c1b/watch',
            'right-8':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0469988cda0f76f960e83527a925ba17/watch',
            'right-9':  'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0469988cda0f76f960e83527a925ba17/watch',
            'right-10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6f42dd7f752aa34e6dc835e3c8410b8c/watch'
        },
        'supplements': {
            // OLD 'glutathione': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/e8eb7f8addf57473c0b54bc0b889a8c6/watch',
            'attention-vitamins': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ac7cb9da901dbf81a5438a1a87c25581/watch',
            'learning-vitamins': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/0bc397c10455c02c94e18c77d19b4a3c/watch',
            'digestion-vitamins': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/5569ee79880c66c1bcb1a9598e7f7583/watch',
            'magnesium': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/a16807dfd53a1d92cc66c0eb1c797947/watch',
            'omegas': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/3f10ddb1449270558cdab100fb91ed08/watch',
            'th': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/fd4c632ab2dd655d3222ede738bb2e7d/watch',
            'vitamin-a': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8adc4a08cf58d71bbcf0895a76bae708/watch',
            'vitamin-d': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/cb8f1bb0e129e502a95696796a55f425/watch',
            'berberine': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/57eab48f3a7a1bff653a62b847881bb8/watch',
            'gut-vitamin': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/38a9c728f70fe19726d2d967a163cac5/watch',
            'b12': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8cc08e7a28c1a4cc27dc17c2088009d7/watch',
            'attention-focus-calm': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8a623ee56a7601d25182064e4f949bd4/watch',
            'th2-modulator': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/74e77e05b3808f915a8a1cf79be874de/watch',
            'pro-omega-2000': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/ebb01a90cd6ccdeb970c5c948643097c/watch',
            'quercetin-spray': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/009c7d9194b64923a1bc71258e8a0bdb/watch',
            'th1-support': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/9cf53569f327b4f2745f70cb6087b2f7/watch',
            'co-q10': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/b3e691a03b420fa0d8608053d0c6f3ae/watch',
            'glutathione': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/daf6d46b68dee763455e206b0d393914/watch',
            'zeolinte-spray': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/de2fc692e19271e723b70df70f417353/watch'
        },
        'sallie-instructions': {
            // 'melillopatient-reg': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1674d90cf6ff3841cec74383c7e860f1/watch',
            // 'melillopatient-salliereg': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/8bef113cc27e664fd1ae7433ddeb3102/watch',
            // 'melillopatient-dashboard': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/7c5122bc2ad51a86aa2d9cbfe674327c/watch',
            // 'melillopatient-step2': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/db2c84295880a8d28a9a406d44c66add/watch',
            // 'melillopatient-step3': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/012d9e785764f04594702c3466508a22/watch',
            // 'melillopatient-dailytracking': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/aa721db4d66cc58ec06ef76d7bd59354/watch',
            // 'melillopatient-darkmode': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/d1877a4551b478d50c20cea100e6894c/watch',
            'english-patient-dashboard': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/1f9b46551c242d4c6f9f18098a3b010b/watch',
            'english-provider-dashboard': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/6e6aa2f99e58af68ce925dada772829c/watch',
            'spanish-patient-dashboard': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/56cfa9af6239fcaccf76d4cf395d7696/watch',
            'spanish-provider-dashboard': 'https://customer-hywi166rmnzn7jfo.cloudflarestream.com/2b2ef8961b3a4e7448b23ab681183d47/watch'
        }
};






export const videoGroups = [
        {
            id: 'intro-videos',
            name: 'Intro Videos',
            items: [
                { id: 'doc-melillo-message', name: 'DocMelillo-Message' },
                { id: 'melillo-method-prep', name: 'Dr. Melillo-Melillo Method Preparation' },
                { id: 'report-of-finding', name: 'DrMelillo-Report-of-Finding' },
                { id: '10-level-system', name: '10 Level System Video from Zoom' },
            //    { id: 'sallie', name: 'Sallie Intro' },
            //    { id: 'sallie_spanish', name: 'Sallie Intro (Spanish)' },
                { id: 'qeeg-intro', name: 'QEEG- Intro and Overview for Patients and Staff' },
            ],
            subgroups: [
                {
                    id: 'staff-intro',
                    name: 'Introduction Videos',
                    items: [
                        { id: 'bridget-intro', name: 'Bridget Introduction Video' },
                        { id: 'jesse-intro', name: 'Jesse Introduction Video' },
                        { id: 'ty-intro', name: 'Ty Introduction Video' }
                    ]
                }
            ],
            additionalItems: [
                { id: 'intro-to-rpm', name: 'Intro to RPM' }
            ]
        },
        {
            id: 'primitive-reflex',
            name: 'Primitive Reflex Treatments',
            items: [
                { id: 'pr-intro-home', name: 'Melillo-Intro to the Home Program' }
            ],
            subgroups: [
                {
                    id: 'pr-levels-1',
                    name: 'Level 1',
                    items: [
                        { id: 'pr-dr-intro', name: 'Dr. Melillo Introduction' },
                        { id: 'pr-intro-1', name: 'Intro to Level 1' },
                        { id: 'pg-1', name: 'Palmer Grasp Level 1' },
                        { id: 'pg-1-rez', name: 'Palmer Grasp Level 1- Rezzimax' },
                        { id: 'root-1', name: 'Rooting Level 1' },
                        { id: 'root-1-rez', name: 'Rooting Level 1-Rezzimax' },
                        { id: 'snout-1', name: 'Snout Level 1' },
                        { id: 'snout-1-rez', name: 'Snout Level 1- Rezzimax' },
                        { id: 'bab-1', name: 'Babinski Level 1' },
                        { id: 'bab-1-rez', name: 'Babinski Level 1-Rezzimax' },
                        { id: 'sg-1', name: 'Spinal Galant Level 1' },
                        { id: 'sg-1-rez', name: 'Spinal Galant Level 1-Rezzimax' },
                        { id: 'atnr-1', name: 'ATNR Level 1' },
                        { id: 'stnr-1', name: 'STNR Level 1' },
                        { id: 'moro-1', name: 'Moro Level 1' },
                        { id: 'tlr-1', name: 'TLR Level 1' }
                    ]
                },
                {
                    id: 'pr-levels-2',
                    name: 'Level 2',
                    items: [
                        { id: 'pr-dr-intro', name: 'Dr. Melillo Introduction' },
                        { id: 'pr-intro-2', name: 'Intro to Level 2' },
                        { id: 'pg-2', name: 'Palmer Grasp Level 2' },
                        { id: 'pg-2-rez', name: 'Palmer Grasp Level 2- Rezzimax' },
                        { id: 'root-2', name: 'Rooting Level 2' },
                        { id: 'root-2-rez', name: 'Rooting Level 2-Rezzimax' },
                        { id: 'snout-2', name: 'Snout Level 2' },
                        { id: 'snout-2-rez', name: 'Snout Level 2- Rezzimax' },
                        { id: 'bab-2', name: 'Babinski Level 2' },
                        { id: 'bab-2-rez', name: 'Babinski Level 2-Rezzimax' },
                        { id: 'sg-2', name: 'Spinal Galant Level 2' },
                        { id: 'sg-2-rez', name: 'Spinal Galant Level 2-Rezzimax' },
                        { id: 'atnr-2', name: 'ATNR Level 2' },
                        { id: 'stnr-2', name: 'STNR Level 2' },
                        { id: 'moro-2', name: 'Moro Level 2' },
                        { id: 'tlr-2', name: 'TLR Level 2' }
                    ]
                },
                {
                    id: 'pr-levels-3',
                    name: 'Level 3',
                    items: [
                        { id: 'pr-intro-3', name: 'Intro to Level 3' },
                        { id: 'pg-3', name: 'Palmer Grasp Level 3' },
                        { id: 'pg-3-rez', name: 'Palmer Grasp Level 3- Rezzimax' },
                        { id: 'root-3', name: 'Rooting Level 3' },
                        { id: 'root-3-rez', name: 'Rooting Level 3- Rezzimax' },
                        { id: 'snout-3', name: 'Snout Level 3' },
                        { id: 'snout-3-rez', name: 'Snout Level 3-Rezzimax' },
                        { id: 'bab-3', name: 'Babinski Level 3' },
                        { id: 'bab-3-rez', name: 'Babinski Level 3-Rezzimax' },
                        { id: 'sg-3', name: 'Spinal Galant Level 3' },
                        { id: 'sg-3-rez', name: 'Spinal Galant Level 3-Rezzimax' },
                        { id: 'atnr-3', name: 'ATNR Level 3' },
                        { id: 'stnr-3', name: 'STNR Level 3' },
                        { id: 'moro-3', name: 'Moro Level 3' },
                        { id: 'tlr-3', name: 'TLR Level 3' }
                    ]
                },
                {
                    id: 'pr-level-4',
                    name: 'Level 4',
                    items: [
                        { id: 'pr-intro-4', name: 'Intro to Level 4' },
                        { id: 'pg-4', name: 'Palmer Grasp Level 4' },
                        { id: 'pg-4-rez', name: 'Palmer Grasp Level 4- Rezzimax' },
                        { id: 'root-4', name: 'Rooting Level 4' },
                        { id: 'root-4-rez', name: 'Rooting Level 4- Rezzimax' },
                        { id: 'snout-4', name: 'Snout Level 4' },
                        { id: 'snout-4-rez', name: 'Snout Level 4-Rezzimax' },
                        { id: 'bab-4', name: 'Babinski Level 4' },
                        { id: 'bab-4-rez', name: 'Babinski Level 4-Rezzimax' },
                        { id: 'sg-4', name: 'Spinal Galant Level 4' },
                        { id: 'sg-4-rez', name: 'Spinal Galant Level 4-Rezzimax' },
                        { id: 'atnr-4', name: 'ATNR Level 4' },
                        { id: 'stnr-4', name: 'STNR Level 4' },
                        { id: 'moro-4', name: 'Moro Level 4' },
                        { id: 'tlr-4', name: 'TLR Level 4' }
                    ]
                },
                {
                    id: 'pr-level-5',
                    name: 'Level 5',
                    items: [
                        { id: 'pg-5', name: 'Palmer Grasp Level 5' },
                        { id: 'root-5', name: 'Rooting Level 5' },
                        { id: 'snout-5', name: 'Snout Level 5' },
                        { id: 'bab-5', name: 'Babinski Level 5' },
                        { id: 'sg-5', name: 'Spinal Galant Level 5' },
                        { id: 'atnr-5', name: 'ATNR Level 5' },
                        { id: 'stnr-5', name: 'STNR Level 5' },
                        { id: 'moro-5', name: 'Moro Level 5' },
                        { id: 'tlr-5', name: 'TLR Level 5' }
                    ]
                },
                {
                    id: 'pr-level-6',
                    name: 'Level 6',
                    items: [
                        { id: 'pg-6', name: 'Palmer Grasp Level 6' },
                        { id: 'root-6', name: 'Rooting Level 6' },
                        { id: 'root-6-rez', name: 'Rooting Level 6-Rezzimax' },
                        { id: 'snout-6', name: 'Snout Level 6' },
                        { id: 'snout-6-rez', name: 'Snout Level 6- Rezzimax' },
                        { id: 'bab-6', name: 'Babinski Level 6' },
                        { id: 'sg-6', name: 'Spinal Galant Level 6' },
                        { id: 'atnr-6', name: 'ATNR Level 6' },
                        { id: 'stnr-6', name: 'STNR Level 6' },
                        { id: 'moro-6', name: 'Moro Level 6' },
                        { id: 'tlr-6', name: 'TLR Level 6' }
                    ]
                },
                {
                    id: 'pr-level-7',
                    name: 'Level 7',
                    items: [
                        { id: 'pg-7', name: 'Palmer Grasp Level 7' },
                        { id: 'root-snout-7', name: 'Rooting & Snout Level 7' },
                        { id: 'bab-7', name: 'Babinski Level 7' },
                        { id: 'sg-7', name: 'Spinal Galant Level 7' },
                        { id: 'atnr-7', name: 'ATNR Level 7' },
                        { id: 'stnr-7', name: 'STNR Level 7' },
                        { id: 'moro-7', name: 'Moro Level 7' },
                        { id: 'tlr-7', name: 'TLR Level 7' }
                    ]
                },
                {
                    id: 'pr-level-8',
                    name: 'Level 8',
                    items: [
                        { id: 'pg-8', name: 'Palmer Grasp Level 8' },
                        { id: 'root-snout-8', name: 'Rooting & Snout Level 8' },
                        { id: 'bab-8', name: 'Babinski Level 8' },
                        { id: 'sg-8', name: 'Spinal Galant Level 8' },
                        { id: 'atnr-8', name: 'ATNR Level 8' },
                        { id: 'stnr-8', name: 'STNR Level 8' },
                        { id: 'moro-8', name: 'Moro Level 8' },
                        { id: 'tlr-8', name: 'TLR Level 8' }
                    ]
                },
                {
                    id: 'pr-level-9',
                    name: 'Level 9',
                    items: [
                        { id: 'pg-9', name: 'Palmer Grasp Level 9' },
                        { id: 'root-snout-9', name: 'Rooting & Snout Level 9' },
                        { id: 'bab-9', name: 'Babinski Level 9' },
                        { id: 'sg-9', name: 'Spinal Galant Level 9' },
                        { id: 'atnr-9', name: 'ATNR Level 9' },
                        { id: 'stnr-9', name: 'STNR Level 9' },
                        { id: 'moro-9', name: 'Moro Level 9' },
                        { id: 'tlr-9', name: 'TLR Level 9' }
                    ]
                },
                {
                    id: 'pr-level-10',
                    name: 'Level 10',
                    items: [
                        { id: 'pg-10', name: 'Palmer Grasp Level 10' },
                        { id: 'root-snout-10', name: 'Rooting & Snout Level 10' },
                        { id: 'bab-10', name: 'Babinski Level 10' },
                        { id: 'sg-10', name: 'Spinal Galant Level 10' },
                        { id: 'atnr-10', name: 'ATNR Level 10' },
                        { id: 'stnr-10', name: 'STNR Level 10' },
                        { id: 'moro-10', name: 'Moro Level 10' },
                        { id: 'tlr-10', name: 'TLR Level 10' }
                    ]
                }
            ]
        },
        {
            id: 'core-exercises',
            name: 'Core Exercises',
            subgroups: [
                {
                    id: 'core-level-1',
                    name: 'Level 1',
                    items: [
                        { id: 'sb-1', name: 'Supine Bridge Level 1' },
                        { id: 'cu-1', name: 'Curl Ups Level 1' },
                        { id: 'lsp-1', name: 'Lateral Side Plank Level 1' },
                        { id: 'pb-1', name: 'Prone Bridge Level 1' },
                        { id: 'pu-1', name: 'Pull Ups Level 1' },
                        { id: 'psh-1', name: 'Push Ups Level 1' }
                    ]
                },
                {
                    id: 'core-level-2',
                    name: 'Level 2',
                    items: [
                        { id: 'sb-2', name: 'Supine Bridge Level 2' },
                        { id: 'cu-2', name: 'Curl Ups Level 2' },
                        { id: 'lsp-2', name: 'Lateral Side Plank Level 2' },
                        { id: 'pb-2', name: 'Prone Bridge Level 2' },
                        { id: 'pu-2', name: 'Pull Ups Level 2' },
                        { id: 'psh-2', name: 'Push Ups Level 2' }
                    ]
                },
                {
                    id: 'core-level-3',
                    name: 'Level 3',
                    items: [
                        { id: 'sb-3', name: 'Supine Bridge Level 3' },
                        { id: 'cu-3', name: 'Curl Ups Level 3' },
                        { id: 'lsp-3', name: 'Lateral Side Plank Level 3' },
                        { id: 'pb-3', name: 'Prone Bridge Level 3' },
                        { id: 'pu-3', name: 'Pull Ups Level 3' },
                        { id: 'psh-3', name: 'Push Ups Level 3' }
                    ]
                },
                {
                    id: 'core-level-4',
                    name: 'Level 4',
                    items: [
                        { id: 'sb-4', name: 'Supine Bridge Level 4' },
                        { id: 'cu-4', name: 'Curl Ups Level 4' },
                        { id: 'lsp-4', name: 'Lateral Side Plank Level 4' },
                        { id: 'pb-4', name: 'Prone Bridge Level 4' },
                        { id: 'pu-4', name: 'Pull Ups Level 4' },
                        { id: 'psh-4', name: 'Push Ups Level 4' }
                    ]
                },
                {
                    id: 'core-level-5',
                    name: 'Level 5',
                    items: [
                        { id: 'sb-5', name: 'Supine Bridge Level 5' },
                        { id: 'cu-5', name: 'Curl Ups Level 5' },
                        { id: 'lsp-5', name: 'Lateral Side Plank Level 5' },
                        { id: 'pb-5', name: 'Prone Bridge Level 5' },
                        { id: 'pu-5', name: 'Pull Ups Level 5' },
                        { id: 'psh-5', name: 'Push Ups Level 5' }
                    ]
                },
                {
                    id: 'core-level-6',
                    name: 'Level 6',
                    items: [
                        { id: 'sb-6', name: 'Supine Bridge Level 6' },
                        { id: 'cu-6', name: 'Curl Ups Level 6' },
                        { id: 'lsp-6', name: 'Lateral Side Plank Level 6' },
                        { id: 'pb-6', name: 'Prone Bridge Level 6' },
                        { id: 'pu-6', name: 'Pull Ups Level 6' },
                        { id: 'psh-6', name: 'Push Ups Level 6' }
                    ]
                },
                {
                    id: 'core-level-7',
                    name: 'Level 7',
                    items: [
                        { id: 'sb-7', name: 'Supine Bridge Level 7' },
                        { id: 'cu-7', name: 'Curl Ups Level 7' },
                        { id: 'lsp-7', name: 'Lateral Side Plank Level 7' },
                        { id: 'pb-7', name: 'Prone Bridge Level 7' },
                        { id: 'pu-7', name: 'Pull Ups Level 7' },
                        { id: 'psh-7', name: 'Push Ups Level 7' }
                    ]
                },
                {
                    id: 'core-level-8',
                    name: 'Level 8',
                    items: [
                        { id: 'sb-8', name: 'Supine Bridge Level 8' },
                        { id: 'cu-8', name: 'Curl Ups Level 8' },
                        { id: 'lsp-8', name: 'Lateral Side Plank Level 8' },
                        { id: 'pb-8', name: 'Prone Bridge Level 8' },
                        { id: 'pu-8', name: 'Pull Ups Level 8' },
                        { id: 'psh-8', name: 'Push Ups Level 8' }
                    ]
                },
                {
                    id: 'core-level-9',
                    name: 'Level 9',
                    items: [
                        { id: 'sb-9', name: 'Supine Bridge Level 9' },
                        { id: 'cu-9', name: 'Curl Ups Level 9' },
                        { id: 'lsp-9', name: 'Lateral Side Plank Level 9' },
                        { id: 'pb-9', name: 'Prone Bridge Level 9' },
                        { id: 'pu-9', name: 'Pull Ups Level 9' },
                        { id: 'psh-9', name: 'Push Ups Level 9' }
                    ]
                },
                {
                    id: 'core-level-10',
                    name: 'Level 10',
                    items: [
                        { id: 'sb-10', name: 'Supine Bridge Level 10' },
                        { id: 'cu-10', name: 'Curl Ups Level 10' },
                        { id: 'lsp-10', name: 'Lateral Side Plank Level 10' },
                        { id: 'pb-10', name: 'Prone Bridge Level 10' },
                        { id: 'pu-10', name: 'Pull Ups Level 10' },
                        { id: 'psh-10', name: 'Push Ups Level 10' }
                    ]
                }
            ]
        },
        {
            id: 'balance',
            name: 'Balance Exercises',
            items: [
                { id: 'bal-1', name: 'Level 1' },
                { id: 'bal-2', name: 'Level 2' },
                { id: 'bal-3', name: 'Level 3' },
                { id: 'bal-4', name: 'Level 4' },
                { id: 'bal-5', name: 'Level 5' },
                { id: 'bal-6', name: 'Level 6' },
                { id: 'bal-7', name: 'Level 7' },
                { id: 'bal-8', name: 'Level 8' },
                { id: 'bal-9', name: 'Level 9' },
                { id: 'bal-10', name: 'Level 10' }
            ]
        },
        {
            id: 'oculomotor',
            name: 'Oculomotor Exercises',
            items: [
                { id: 'okn-drum', name: 'OKN Drum Instructions' },
                { id: 'ocul-1', name: 'Level 1' },
                { id: 'ocul-2', name: 'Level 2' },
                { id: 'ocul-3', name: 'Level 3' },
                { id: 'ocul-4', name: 'Level 4' },
                { id: 'ocul-5', name: 'Level 5' },
                { id: 'ocul-6', name: 'Level 6' },
                { id: 'ocul-7', name: 'Level 7' },
                { id: 'ocul-8', name: 'Level 8' },
                { id: 'ocul-9', name: 'Level 9' },
                { id: 'ocul-10', name: 'Level 10' }
            ]
        },
        {
            id: 'vestibular',
            name: 'Vestibular Treatment',
            items: [
                { id: 'vest-1', name: 'Level 1' },
                { id: 'vest-2', name: 'Level 2' },
                { id: 'vest-3', name: 'Level 3' },
                { id: 'vest-4', name: 'Level 4' },
                { id: 'vest-5', name: 'Level 5' },
                { id: 'vest-6', name: 'Level 6' },
                { id: 'vest-7', name: 'Level 7' },
                { id: 'vest-8', name: 'Level 8' },
                { id: 'vest-9', name: 'Level 9' },
                { id: 'vest-10', name: 'Level 10' }
            ]
        },
        {
            id: 'olfactory',
            name: 'Olfactory Treatment',
            items: [
                { id: 'olf-1', name: 'Level 1' },
                { id: 'olf-2', name: 'Level 2' },
                { id: 'olf-3', name: 'Level 3' },
                { id: 'olf-4', name: 'Level 4' },
                { id: 'olf-5', name: 'Level 5' },
                { id: 'olf-6', name: 'Level 6' },
                { id: 'olf-7', name: 'Level 7' },
                { id: 'olf-8', name: 'Level 8' },
                { id: 'olf-9', name: 'Level 9' },
                { id: 'olf-10', name: 'Level 10' }
            ]
        },
        {
            id: 'rhythm-timing',
            name: 'Rhythm and Timing- Metrotimer and Interactive Metronome',
            subgroups: [
                {
                    id: 'metrotimer',
                    name: 'Metrotimer Treatment',
                    items: [
                        { id: 'metro-intro', name: 'Metro Timer - Intro' },
                        { id: 'metro-1', name: 'Level 1' },
                        { id: 'metro-2', name: 'Level 2' },
                        { id: 'metro-3', name: 'Level 3' },
                        { id: 'metro-4', name: 'Level 4' },
                        { id: 'metro-5', name: 'Level 5' },
                        { id: 'metro-6', name: 'Level 6' },
                        { id: 'metro-7', name: 'Level 7' },
                        { id: 'metro-8', name: 'Level 8' },
                        { id: 'metro-9', name: 'Level 9' },
                        { id: 'metro-10', name: 'Level 10' }
                    ]
                },
                {
                    id: 'interactive-metronome',
                    name: 'Interactive Metronome Treatment',
                    items: [
                        { id: 'int-metro-1', name: 'Level 1' },
                        { id: 'int-metro-2', name: 'Level 2' },
                        { id: 'int-metro-3', name: 'Level 3' },
                        { id: 'int-metro-4', name: 'Level 4' },
                        { id: 'int-metro-5', name: 'Level 5' },
                        { id: 'int-metro-6', name: 'Level 6' },
                        { id: 'int-metro-7', name: 'Level 7' },
                        { id: 'int-metro-8', name: 'Level 8' },
                        { id: 'int-metro-9', name: 'Level 9' },
                        { id: 'int-metro-10', name: 'Level 10' }
                    ]
                }
            ]
        },
        {
            id: 'sensory-equipment',
            name: 'Sensory Stimulation Equipment Instructions',
            items: [
                { id: 'galvanic', name: 'Galvanic Instruction' },
                { id: 'bone-conduction', name: 'Bone Conduction Headphone Instruction' },
                { id: 'tens', name: 'TENS instructions' }
            ],
            subgroups: [
                {
                    id: 'transcranial',
                    name: 'Transcranial Stimulation',
                    items: [
                        { id: 'trans-brain-driver', name: 'Melillo-Transcranial Direct Current Instructional-Brain Driver' },
                        { id: 'trans-saline', name: 'Melillo- Transcranial - Saline Solution and sponge pads' },
                        { id: 'trans-level-select', name: 'Transcranial Level selection and progression' },
                        { id: 'trans-1', name: 'Transcranial Treatment Level 1' },
                        { id: 'trans-2', name: 'Transcranial Treatment Level 2' },
                        { id: 'trans-3', name: 'Transcranial Treatment Level 3' },
                        { id: 'trans-4', name: 'Transcranial Treatment Level 4' },
                        { id: 'trans-5', name: 'Transcranial Treatment Level 5' },
                        { id: 'trans-6', name: 'Transcranial Treatment Level 6' },
                        { id: 'trans-7', name: 'Transcranial Treatment Level 7' },
                        { id: 'trans-8', name: 'Transcranial Treatment Level 8' },
                        { id: 'trans-9', name: 'Transcranial Treatment Level 9' },
                        { id: 'trans-10', name: 'Transcranial Treatment Level 10' }
                    ]
                },
                {
                    id: 'eyelights',
                    name: 'Eyelights',
                    items: [
                        { id: 'eyelights-instructions', name: 'Eyelights Instructions' },
                        { id: 'eyelights-levels', name: 'Melillo-Eyelights Levels' }
                    ]
                },
                {
                    id: 'pons',
                    name: 'PONs stimulator',
                    items: [
                        { id: 'pons-intro', name: 'Translingual Neurostimulation Device Intro' },
                        { id: 'pons-practical', name: 'Translingual Neurostimulation Practical Application' },
                        { id: 'pons-1', name: 'Translingual Neurostimulation- Level 1' },
                        { id: 'pons-2', name: 'Translingual Neurostimulation- Level 2' },
                        { id: 'pons-3', name: 'Translingual Neurostimulation- Level 3' },
                        { id: 'pons-4', name: 'Translingual Neurostimulation- Level 4' },
                        { id: 'pons-5', name: 'Translingual Neurostimulation- Level 5' },
                        { id: 'pons-6', name: 'Translingual Neurostimulation- Level 6' },
                        { id: 'pons-7', name: 'Translingual Neurostimulation- Level 7' },
                        { id: 'pons-8', name: 'Translingual Neurostimulation- Level 8' },
                        { id: 'pons-9', name: 'Translingual Neurostimulation- Level 9' },
                        { id: 'pons-10', name: 'Translingual Neurostimulation- Level 10' }
                    ]
                },
                {
                    id: 'photobiomodulation',
                    name: 'Photobiomodulation - Laser Protocols',
                    items: [
                        { id: 'laser-intro', name: 'Intro-Laser-Protocol' },
                        { id: 'laser-setup', name: 'Photobiomodulation Laser set up' }
                    ],
                    subgroups: [
                        {
                            id: 'left-hemisphere',
                            name: 'Left Hemisphere Laser Protocols',
                            items: [
                                { id: 'left-1',  name: 'Photobiomodulation Level 1 Left Deficit- 1 laser' },
                                { id: 'left-2',  name: 'Photobiomodulation Level 2 Left Deficit- 1 laser' },
                                { id: 'left-3',  name: 'Photobiomodulation Level 3 Left Deficit- 1 laser' },
                                { id: 'left-4',  name: 'Photobiomodulation Level 4 Left Deficit- 1 laser' },
                                { id: 'left-5',  name: 'Photobiomodulation Level 5 Left Deficit- 1 laser' },
                                { id: 'left-6',  name: 'Photobiomodulation Level 6 Left Deficit- 1 laser' },
                                { id: 'left-7',  name: 'Photobiomodulation Level 7 Left Deficit- 1 laser' },
                                { id: 'left-8',  name: 'Photobiomodulation Level 8 Left Deficit- 1 laser' },
                                { id: 'left-9',  name: 'Photobiomodulation Level 9 Left Deficit- 1 laser' },
                                { id: 'left-10', name: 'Photobiomodulation Level 10 Left Deficit- 1 laser' }
                            ]
                        },
                        {
                            id: 'right-hemisphere',
                            name: 'Right Hemisphere Laser Protocols',
                            items: [
                                { id: 'right-1',  name: 'Photobiomodulation Level 1 Right Deficit- 1 laser' },
                                { id: 'right-2',  name: 'Photobiomodulation Level 2 Right Deficit- 1 laser' },
                                { id: 'right-3',  name: 'Photobiomodulation Level 3 Right Deficit- 1 laser' },
                                { id: 'right-4',  name: 'Photobiomodulation Level 4 Right Deficit- 1 laser' },
                                { id: 'right-5',  name: 'Photobiomodulation Level 5 Right Deficit- 1 laser' },
                                { id: 'right-6',  name: 'Photobiomodulation Level 6 Right Deficit- 1 laser' },
                                { id: 'right-7',  name: 'Photobiomodulation Level 7 Right Deficit- 1 laser' },
                                { id: 'right-8',  name: 'Photobiomodulation Level 8 Right Deficit- 1 laser' },
                                { id: 'right-9',  name: 'Photobiomodulation Level 9 Right Deficit- 1 laser' },
                                { id: 'right-10', name: 'Photobiomodulation Level 10 Right Deficit- 1 laser' }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: 'supplements',
            name: 'Supplement Instructions',
            items: [
                { id: 'glutathione', name: 'Glutathione' },
                { id: 'attention-vitamins', name: 'Kid Genius Attention Vitamins' },
                { id: 'learning-vitamins', name: 'Learning Memory Concentration Left Brain Vitamins' },
                { id: 'digestion-vitamins', name: 'Kid Genius Digestion Vitamins' },
                { id: 'magnesium', name: 'Magnesium' },
                { id: 'omegas', name: 'Omega Vitamins' },
                { id: 'th', name: 'TH-vits' },
                { id: 'vitamin-a', name: 'Vitamin A' },
                { id: 'vitamin-d', name: 'Vitamin D' },
                { id: 'berberine', name: 'Berberine' },
                { id: 'gut-vitamin', name: 'Gut Vitamin' },
                { id: 'b12', name: 'B12' },
                { id: 'attention-focus-calm', name: 'Attention Focus Calm' },
                { id: 'th2-modulator', name: 'TH2 Modulator' },
                { id: 'pro-omega-2000', name: 'Pro Omega 2000' },
                { id: 'quercetin-spray', name: 'Quercetin Spray' },
                { id: 'th1-support', name: 'TH1 Support' },
                { id: 'co-q10', name: 'Co-Q10' },
                { id: 'zeolinte-spray', name: 'Zeolite Spray' }
            ]
        },
        {
            id: 'sallie-instructions',
            name: 'Sallie Instructions',
            items: [
                // { id: 'melillopatient-reg', name: 'Melillo Patient Registration' },
                // { id: 'melillopatient-salliereg', name: 'Melillo Method Sallie Patient Registration Video' },
                // { id: 'melillopatient-dashboard', name: 'Melillo Method Sallie Patient Dashboard Video' },
                // { id: 'melillopatient-step2', name: 'Melillo Patient Step 2 (Symptoms)' },
                // { id: 'melillopatient-step3', name: 'Melillo Patient Step 3 (TOP Symptoms)' },
                // { id: 'melillopatient-dailytracking', name: 'Patient Daily Tracking Pause Add' },
                // { id: 'melillopatient-darkmode', name: 'Patient Darkmode' },
                // Titles below intentionally match each video's spoken language — no translation keys exist for them
                { id: 'english-patient-dashboard', name: 'English: Patient/Caregiver Dashboard' },
                { id: 'english-provider-dashboard', name: 'English: Provider Dashboard' },
                { id: 'spanish-patient-dashboard', name: 'Español: Panel del Paciente/Cuidador' },
                { id: 'spanish-provider-dashboard', name: 'Español: Panel del Proveedor' }
            ]
        }
];